import axios from 'axios';
import appointments from './appointments';
import user from './user';
import settings from './settings';
import userInfo from './userInfo';
import affiliate from './affiliate';
import medicine from './medicine';
import apiKey from './apiKey';

export const controller = new AbortController();

const nalInstance = axios.create({
  signal: controller.signal,
});

//@ts-ignore
nalInstance.CancelToken = axios.CancelToken;

//Add header to mapi calls ['X-Requested-With'] = 'XMLHttpRequest'
nalInstance.interceptors.request.use(
  function (config: any) {
    if (config.url.startsWith('/api') || config.url.startsWith('/auth'))
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  },
  function (err: any) {
    return Promise.reject(err);
  }
);

const affiliateService = affiliate(nalInstance);
const apiKeyService = apiKey(nalInstance);
const userService = user(nalInstance);
const appointmentsService = appointments(nalInstance);
const medicineService = medicine(nalInstance);
const settingsService = settings(nalInstance);
const userInfoService = userInfo(nalInstance);

export {
  affiliateService,
  apiKeyService,
  userService,
  appointmentsService,
  medicineService,
  settingsService,
  userInfoService,
};
